<template>
    <footer class="page-footer">
        <p class="mb-0">Copyright © 2022. All right reserved.</p>
    </footer>
</template>

<script setup>

</script>